import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule, IMAGE_LOADER, ImageLoaderConfig, NgOptimizedImage } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-image',
    standalone: true,
    imports: [CommonModule, NgOptimizedImage],
    providers: [
        {
            provide: IMAGE_LOADER,
            useValue: (config: ImageLoaderConfig) => `${environment.CDN_URL}${config.src}`
        }
    ],
    template: `
        <img
            *ngIf="isLoaded"
            [alt]="altText"
            [ngSrc]="imgSrc"
            [width]="imgWidth"
            [height]="imgHeight"
            [ngClass]="imgClass"
            [ngStyle]="imgStyle"
            [title]=""
            (error)="isLoaded = false" />
        <img *ngIf="!isLoaded" [ngSrc]="placeholder" [height]="imgWidth" [width]="imgWidth" [alt]="altText" />
        `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageComponent implements OnChanges {
    /* Mandatory Inputs */
    @Input() imgSrc!: string;
    @Input() imgWidth!: number;
    @Input() imgHeight!: number;

    /* Optional Inputs */
    @Input() altText: string = '';
    @Input() imgClass: string = '';
    @Input() imgStyle: { [klass: string]: any } = {};
    @Input() placeholder: string = 'shared/ixfi-default-icon.png';

    isLoaded: boolean = true;

    ngOnChanges(changes: SimpleChanges) {
        if (changes.imgSrc) this.isLoaded = true;
    }
}
